<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-dialog 
         v-model="dialogMap" 
         @input="onDialogChange"
         fullscreen
       >
         <v-card>
             <v-toolbar color="primary" dark>
                 <v-toolbar-title>{{ $t('realTimeKmReport.lastVehiclePosition') }} {{ veiculoSelecionado?.numero_ordem }}</v-toolbar-title>
                 <v-spacer></v-spacer>
                 <v-btn icon @click="closeMap">
                     <v-icon>mdi-close</v-icon>
                 </v-btn>
             </v-toolbar>
           <v-card-text style="padding: 0;">
             <div id="map" ref="mapContainer">
                 <l-map 
                 ref="map"
                 :zoom="15" 
                 :center="currentCenter"
                 @update:center="centerUpdate"
                 @update:zoom="zoomUpdate"
                 @ready="onMapReady"
                 :options="mapOptions"
                 >
                     <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                     <l-marker 
                       v-if="veiculoSelecionado && veiculoSelecionado.lat && veiculoSelecionado.lng"
                       :lat-lng="latLng(veiculoSelecionado)" 
                       :icon="getIcon(veiculoSelecionado)"
                     ></l-marker>
                 </l-map>
             </div>
           </v-card-text>
         </v-card>
       </v-dialog>

      <v-container class="toolbar__container">
        <v-form ref="form" v-model="formValidado">
          <v-row>
            <v-col cols="12" sm="12" md="2">
              <LazySelect
                ref="empresaSelect"
                get-url="getEmpresaslazy"
                text="razao_social"
                value="id_empresa"
                :label="$tc('company.self', 1)"
                @input="onEmpresaInput"
              />
            </v-col>
            <!-- adicionar unidade -->
            <v-col cols="12" sm="12" md="3">
              <MultiplaEscolha
                lazy
                get-url="getUnidadeslazy"
                :items="semUnidadeOption"
                v-bind:selected-items.sync="unidadesSelecionadas"
                text="descricao_unidade"
                value="id_unidade"
                :label="$t('nav.registration.units')"
                :max-items="2"
              />
            </v-col>
            <!-- termina unidade -->
            <v-col cols="12" sm="4" md="2">
            <MultiplaEscolha
              ref="veiculosSelect"
              lazy
              get-url="getVeiculoslazy"
              :request-data="lazySelectRequestData"
              :items="veiculosSelect"
              v-bind:selected-items.sync="idVeiculosSelected"
              text="numero_ordem"
              value="id_veiculo"
              :label="$tc('vehicle.self', 2)"
              :max-items="2"
              :disabled="veiculosDisabled"
            />
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-switch
              v-model="autoRefresh"
              :label="$t('realTimeKmReport.autoUpdate')"
              color="primary"
              @change="toggleAutoRefresh"
            ></v-switch>
          </v-col>
          <v-col cols="12" sm="4" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  fab
                  color="primary darken-1"
                  class="white--text"
                  v-bind="attrs"
                  v-on="on"
                  @click="populaRelatorio"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
      </v-row>
        </v-form>
      </v-container>

      <merus-data-table
        :headers="headersKmTempoRealWithProperties"
        :items="kmTempoReal"
        sort-by="cod_veiculo"
        :sort-desc="false"
        item-key="id_veiculo"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loading"
        :loading-text="$t('system.messages.loading')"
        :item-class="getColorItem"
        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;"
        @update:sort-by="updateSort($event)"
        @update:sort-desc="updateSortDesc($event)"
      

 cod-tabela="RELKMTEMPOREAL__KM_TEMPO_REAL_WITH_PROPERTIES" @update:headers="headersKmTempoRealWithProperties = $event">
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('realTimeKmReport.title')"
                :token="token"
                :items="kmTempoRealSorted"
                csv-title="relkmtemporeal"
                :pdf-title="$t('realTimeKmReport.title')"
                :pdf-headers="pdfExportHeaders"
                pdf-filename="relkmtemporeal"
                :pdf-subtitle="`${razaoSocial}`"
                hide-search
            >
                <template v-slot:add>
                    <v-chip
                        v-if="ultimaAtualizacao"
                        color="primary"
                        outlined
                        class="ml-4"
                    >
                        <v-icon left small>mdi-clock</v-icon>
                        {{ $t('politicaDePrivacidade.lastUpdate') }}: {{ ultimaAtualizacao }}
                    </v-chip>
                    <v-btn
                        color="primary"
                        dark
                        small
                        class="mb-2 mr-2"
                        fab
                        @click="populaRelatorio"
                        :loading="loading"
                        style="margin-left: 10px;"
                    >
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
            </CadastroToolbar>
        </template>

        <template v-slot:item.status_avl_extenso="{ item }">
            <v-chip
              :color="getColorStatus(item)"
              :text-color="'white'"
              small
            >
              <v-icon left small>{{ item.status_avl ? 'mdi-wifi' : 'mdi-wifi-off' }}</v-icon>
              {{ item.status_avl_extenso }}
            </v-chip>
        </template>

        <template v-slot:item.atraso_leitura_canbus="{ item }">
            {{ item.atraso_leitura_canbus ? Math.floor(item.atraso_leitura_canbus / 60) + " min" : "" }}
        </template>

        <template v-slot:item.perc_diff_canbus_virtual="{ item }">
            {{ item.perc_diff_canbus_virtual ? item.perc_diff_canbus_virtual + "%" : "" }}
        </template>

        <template v-slot:item.actions="{ item }">
            <v-icon small color="blue" @click="openMap(item)">mdi-map-marker</v-icon>
        </template>

    </merus-data-table>
    </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import LazySelect from './Selects/LazySelect.vue';
import { isHeaderSelectedForExport } from '@/utils/relatorioExportProfiles';

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
        LMap,
        LTileLayer,
        LMarker,
        MultiplaEscolha,
        LazySelect,
    },
    data: () => ({
    headersKmTempoRealWithProperties: [],
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        user: null,
        token: null,
        config: null,
        loading: false,
        dti: null,
        dtf: null,
        idEmpresaSelected: null,
        empresaRazaoSocial: null,
        veiculos: [],
        veiculosSelect: [],
        idVeiculosSelected: [],
        unidadesSelecionadas: [],
        veiculosDisabled: false,
        autoRefresh: false,
        refreshInterval: null,
        ultimaAtualizacao: null,

        kmTempoReal: [],
        formValidado: false,
        sortBy: null,
        sortDesc: false,
        veiculoSelecionado: null,
        dialogMap: false,
        defaultCenter: [-22.88746, -43.29185],
        currentCenter: null,
        mapOptions: {
            zoomSnap: 0.5,
            preferCanvas: true,
        },
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    beforeDestroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    },
    watch: {
        dialogMap(newVal) {
            if (newVal) {
                // Aguarda o próximo tick para garantir que o DOM seja renderizado
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.resizeMap();
                    }, 300); // Delay adicional para garantir que o dialog esteja completamente aberto
                });
            }
        },
        '$i18n.locale'() {
            this.initialize();
        },
        unidadesSelecionadas() {
            this.populaVeiculosSelect();
        },
    },
    computed: {
      center() {
        return this.$store.getters['config/centerDefault'];
      },
      /** Headers fixos para PDF/CSV se a config do banco ainda não carregou ou veio sem colunas exportáveis. */
      defaultExportHeaders() {
        return [
          { text: this.$t('relStatusVehicle.headers.codeVehicle'), value: 'cod_veiculo', to_export: 1 },
          { text: this.$t('fields.vehicle'), value: 'numero_ordem', to_export: 1 },
          { text: this.$t('crudVeiculos.fields.chassi'), value: 'chassi', to_export: 1 },
          { text: this.$t('realTimeKmReport.headers.year'), value: 'ano_modelo', to_export: 1 },
          { text: this.$t('relVehicleKm.headersVeiculosKm.equipment'), value: 'cod_equipamento', to_export: 1 },
          { text: this.$t('relatoriosExtenso.headers.status'), value: 'status_avl_extenso', to_export: 1 },
          { text: this.$t('realTimeKmReport.headers.virtualOdometer'), value: 'hodometro_virtual', to_export: 1 },
          { text: this.$t('realTimeKmReport.headers.canbusOdometer'), value: 'hodometro_canbus', to_export: 1 },
          { text: this.$t('realTimeKmReport.headers.canbusVirtualDifference'), value: 'diff_canbus_virtual', to_export: 1 },
          { text: this.$t('realTimeKmReport.headers.canbusVirtualDifferencePercent'), value: 'perc_diff_canbus_virtual', to_export: 1 },
          { text: this.$t('realTimeKmReport.headers.virtualReadingDate'), value: 'dt_hodometro_virtual_extenso', to_export: 1 },
          { text: this.$t('realTimeKmReport.headers.canbusReadingDate'), value: 'dt_hodometro_canbus_extenso', to_export: 1 },
          { text: this.$t('realTimeKmReport.headers.lastPositionDate'), value: 'dt_ultima_posicao_extenso', to_export: 1 },
          { text: this.$t('realTimeKmReport.headers.canbusReadingDelay'), value: 'atraso_leitura_canbus', to_export: 1 },
        ];
      },
      pdfExportHeaders() {
        const fromTable = (this.headersKmTempoRealWithProperties || []).filter(
          (h) => h && h.value && h.value !== 'actions' && h.align !== ' d-none' && isHeaderSelectedForExport(h)
        );
        return fromTable.length > 0 ? fromTable : this.defaultExportHeaders;
      },
    razaoSocial() {
        return this.empresaRazaoSocial || this.$t('realTimeKmReport.allCompanies');
      },
      semUnidadeOption() {
        return [
          {
            id_unidade: -1,
            descricao_unidade: 'Sem Unidade',
            cod_unidade: 'SU',
          },
        ];
      },
      lazySelectRequestData() {
        const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
        const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
        const temSemUnidade = unidades.includes(-1);
        if (reais.length === 1 && !temSemUnidade) {
          return { id_unidade: reais[0] };
        }
        if (temSemUnidade && reais.length === 0) {
          return { id_unidade: -1 };
        }
        return {};
      },
      kmTempoRealSorted() {
        if (!this.sortBy) {
          return this.kmTempoReal;
        }

        if (["hodometro_virtual", "hodometro_canbus", "diff_canbus_virtual", "atraso_leitura_virtual", "atraso_leitura_canbus", "atraso_canbus_virtual"].includes(this.sortBy)) {
          return [...this.kmTempoReal.filter((e) => !isNaN(parseFloat(e[this.sortBy]))).sort((a, b) => {
            let result = 0;

            if (parseFloat(a[this.sortBy]) > parseFloat(b[this.sortBy])) {
              result = 1;
            } else if (parseFloat(a[this.sortBy]) == parseFloat(b[this.sortBy])) {
              result = 0;
            } else {
              result = -1;
            }
            return this.sortDesc ? -1 * result : result;
          }), ...this.kmTempoReal.filter((e) => isNaN(parseFloat(e[this.sortBy])))];
        } else {
          return [...this.kmTempoReal].sort((a, b) => {
            let result = 0;

            if (!a[this.sortBy]) {
              result = -1;
            } else if (!b[this.sortBy]) { 
              result = 1;
            } else {
              if (a[this.sortBy] > b[this.sortBy]) {
                result = 1;
              } else if (a[this.sortBy] == b[this.sortBy]) {
                result = 0;
              } else {
                result = -1;
              }
            }

            return this.sortDesc ? -1 * result : result;
          });
        }
      }
    },
    methods: {

        idsUnidadesNoObjeto(o) {
          if (Array.isArray(o.unidades) && o.unidades.length) {
            return o.unidades.map((id) => Number(id));
          }
          if (o.id_unidade != null && o.id_unidade !== "") {
            return [Number(o.id_unidade)];
          }
          return [];
        },
        passaFiltroUnidades(o) {
          if (this.unidadesSelecionadas.length === 0) {
            return true;
          }
          const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
          const rowUnidades = this.idsUnidadesNoObjeto(o);
          const semUnidadeSelected = selecionadas.includes(-1);
          const objetoSemUnidade = rowUnidades.length === 0 || rowUnidades.includes(-1);
          const matchesUnidade = selecionadas.some(
            (sid) => sid !== -1 && rowUnidades.includes(sid)
          );
          return matchesUnidade || (semUnidadeSelected && objetoSemUnidade);
        },
        filtraItensLazyParaIds(dados) {
          if (!dados || !Array.isArray(dados)) {
            return [];
          }
          let filtrados = dados;
          if (this.idEmpresaSelected) {
            filtrados = filtrados.filter((d) => d.id_empresa == this.idEmpresaSelected);
          } else if (this.user && this.user.id_cliente != null && this.user.id_cliente !== '') {
            filtrados = filtrados.filter((d) => d.id_cliente == this.user.id_cliente);
          }
          if (this.unidadesSelecionadas.length > 0) {
            const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
            filtrados = filtrados.filter((d) => {
              if (Array.isArray(d.unidades) && d.unidades.length > 0) {
                return d.unidades.map((id) => Number(id)).some((u) => selecionadas.includes(u));
              }
              if (d.id_unidade != null && d.id_unidade !== '') {
                return selecionadas.includes(Number(d.id_unidade));
              }
              if (d.id_linha != null && d.id_veiculo == null && d.id_funcionario == null) {
                return true;
              }
              return selecionadas.includes(-1);
            });
          }
          return filtrados;
        },
        async resolveLazySelectIds(refName, selectedIds, valueKey) {
          if (Array.isArray(selectedIds) && selectedIds.length > 0) {
            return { ids: selectedIds, implicit: false };
          }
          const selectRef = this.$refs[refName];
          if (!selectRef || typeof selectRef.fetchAllLazyItems !== 'function') {
            return { ids: [], implicit: true };
          }
          const { items } = await selectRef.fetchAllLazyItems({
            search: '',
            requestDataOverride: this.lazySelectRequestData,
          });
          const ids = this.filtraItensLazyParaIds(items || [])
            .map((item) => item[valueKey])
            .filter((id) => id != null && id !== '');
          return { ids, implicit: true };
        },
        logout() {
          sessionStorage.removeItem("user");
          sessionStorage.removeItem("api");
          var id = window.setTimeout(function () {}, 0);
          while (id--) {
            window.clearTimeout(id);
          }
          this.$router.push({ path: "/" });
        },
        initialize() {
          this.currentCenter = this.center;
          this.populaVeiculos();
        },
        onEmpresaInput(id) {
          this.idEmpresaSelected = id;
          const item = this.$refs.empresaSelect && this.$refs.empresaSelect.getCachedSelectedItem
            ? this.$refs.empresaSelect.getCachedSelectedItem(id)
            : null;
          this.empresaRazaoSocial = item && item.razao_social ? item.razao_social : null;
          this.idVeiculosSelected = [];
          this.populaVeiculosSelect();
        },
        populaVeiculos() {
          apiController.request(apiController.endpoints.getallVeiculosativos, {
            onSuccess: (response) => {
              this.veiculos = response.data || [];
              this.populaVeiculosSelect();
            },
          });
        },
        populaVeiculosSelect() {
          let veiculosFiltrados = this.veiculos;
          if (this.idEmpresaSelected) {
            veiculosFiltrados = veiculosFiltrados.filter((v) => v.id_empresa == this.idEmpresaSelected);
          }
          veiculosFiltrados = veiculosFiltrados.filter((v) => this.passaFiltroUnidades(v));
          this.veiculosSelect = veiculosFiltrados.map((v) => ({
            ...v,
            numero_ordem: v.numero_ordem || v.cod_veiculo || v.placa || String(v.id_veiculo),
          }));
        },
        populaKmTempoReal(body) {
          apiController.request(apiController.endpoints.getVeiculosrelatoriokmtemporeal, {
            data: body,
            onSuccess: (response) => {
              let dados = response.data || [];
              dados = dados.filter((v) => this.passaFiltroUnidades(v));
              this.kmTempoReal = dados;
              this.ultimaAtualizacao = new Date().toLocaleString();
              if (!this.sortBy) {
                this.sortBy = "status_avl";
                this.sortDesc = true;
              }
              this.loading = false;
            },
            onError: () => {
              this.loading = false;
            },
          });
        },
        async populaRelatorio() {
            this.formValidado = this.$refs.form.validate();
            if (this.formValidado) {
              this.loading = true;
              const { ids, implicit } = await this.resolveLazySelectIds(
                'veiculosSelect',
                this.idVeiculosSelected,
                'id_veiculo',
              );
              if (implicit && ids.length === 0) {
                this.loading = false;
                return;
              }
              this.populaKmTempoReal(ids);
            }
        },
        toggleAutoRefresh() {
          if (this.autoRefresh) {
            this.refreshInterval = setInterval(() => {
              if (this.formValidado) {
                this.populaRelatorio();
              }
            }, 30000); // Atualiza a cada 30 segundos
          } else {
            if (this.refreshInterval) {
              clearInterval(this.refreshInterval);
              this.refreshInterval = null;
            }
          }
        },
        updateSort(event) {
          this.sortBy = event;
        },
        updateSortDesc(event) {
          this.sortDesc = event;
        },
        getColorItem(item) {
          if (item.status_avl === 0) {
            return "item__offline";
          }

          if (!item.hodometro_canbus) {
            return "item__online__sem__can";
          }

          return "item__online";
        },
        getColorStatus(item) {
          if (item.status_avl === 0) {
            return "#d32f2f";
          }

          if (!item.hodometro_canbus) {
            return "#fb8333";
          }

          return "#2E7D32";
        },
        openMap(item) {
          this.veiculoSelecionado = item;
          this.currentCenter = [item.lat, item.lng];
          this.dialogMap = true;
        },
        closeMap() {
          this.dialogMap = false;
          this.veiculoSelecionado = null;
          this.currentCenter = this.defaultCenter;
        },
        latLng(item) {
            if (!item) {
                return null;
            }

            return L.latLng(item.lat, item.lng);
        },
        zoomUpdate(zoom) {
            this.zoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        onMapReady() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.resizeMap();
                }, 100);
            });
        },
        onDialogChange(value) {
            if (value) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.resizeMap();
                    }, 400);
                });
            }
        },
        resizeMap() {
            if (this.$refs.map && this.$refs.map.mapObject) {
                this.$refs.map.mapObject.invalidateSize();
            }
        },
        getIcon(v) {
            if (v) {
                let color = "none";
                let width = "25";
                let height = "25";
                let classname = "my-custom-pin";
    
                if (v.status_avl === 1) {
                    color = "#008000";
                } else if (v.status_avl === 0) {
                    color = "red";
                } else {
                    color = "#4a4a4a";
                }
    
                if (v.status_avl === 0) {
                    classname += " blink";
                }
    
                return L.divIcon({
                    className: classname,
                    html: `<div class="vehicle-icon-container">
                            <svg fill="${color}" width="${width}" height="${height}" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <path d="M12 0C5.4375 0 3 2.167969 3 8L3 41C3 42.359375 3.398438 43.339844 4 44.0625L4 47C4 48.652344 5.347656 50 7 50L11 50C12.652344 50 14 48.652344 14 47L14 46L36 46L36 47C36 48.652344 37.347656 50 39 50L43 50C44.652344 50 46 48.652344 46 47L46 44.0625C46.601563 43.339844 47 42.359375 47 41L47 9C47 4.644531 46.460938 0 40 0 Z M 15 4L36 4C36.554688 4 37 4.449219 37 5L37 7C37 7.550781 36.554688 8 36 8L15 8C14.449219 8 14 7.550781 14 7L14 5C14 4.449219 14.449219 4 15 4 Z M 11 11L39 11C41 11 42 12 42 14L42 26C42 28 40.046875 28.9375 39 28.9375L11 29C9 29 8 28 8 26L8 14C8 12 9 11 11 11 Z M 2 12C0.898438 12 0 12.898438 0 14L0 22C0 23.101563 0.898438 24 2 24 Z M 48 12L48 24C49.105469 24 50 23.101563 50 22L50 14C50 12.898438 49.105469 12 48 12 Z M 11.5 34C13.433594 34 15 35.566406 15 37.5C15 39.433594 13.433594 41 11.5 41C9.566406 41 8 39.433594 8 37.5C8 35.566406 9.566406 34 11.5 34 Z M 38.5 34C40.433594 34 42 35.566406 42 37.5C42 39.433594 40.433594 41 38.5 41C36.566406 41 35 39.433594 35 37.5C35 35.566406 36.566406 34 38.5 34Z"/>
                            </svg>
                        </div>`,
                    iconAnchor: [12, 25]
                });
            }
        },
    }
}
</script>
<style>

.item__online {
  color: #2E7D32;
  font-weight: bold;
}

.item__offline {
  color: #d32f2f;
  font-weight: bold;
}

.item__online__sem__can {
  color: #fb8333;
  font-weight: bold;
}

#map {
    width: 100%;
    height: 90vh;
    position: relative;
    z-index: 0;
}
    
</style>
